import { type ReactElement, useState } from 'react';
import { ClickAwayListener } from '@mui/material';

import { Tooltip } from '../Tooltip';

import { Button } from './components/Button/Button';
import { Separator } from './components/Separator/Separator';

type ControlTooltipProps = {
  renderTarget: (open: boolean) => ReactElement;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'left-end'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  disabled?: boolean;
} & React.PropsWithChildren<unknown>;

export const ControlTooltip = ({
  renderTarget,
  placement,
  children,
  disabled,
}: ControlTooltipProps) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipToogle = () => {
    if (!disabled) {
      setOpen((open) => !open);
    } else {
      setOpen(false);
    }
  };

  const isOpen = open && !disabled;

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          arrow
          onClose={handleTooltipClose}
          open={isOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={children}
          placement={placement || 'bottom'}
          componentsProps={{
            tooltip: {
              sx: { padding: 0, background: '#111' },
            },
            arrow: { sx: { color: '#111' } },
          }}
        >
          <div
            role="button"
            data-testid="tooltip-target"
            onClick={handleTooltipToogle}
          >
            {renderTarget(open)}
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

ControlTooltip.Button = Button;
ControlTooltip.Separator = Separator;
